export default __webpack_public_path__ + "static/media/Resources2.84d43715.png";